const SET_VIDEO_PANEL_STATE = "SET_VIDEO_PANEL_STATE";

const setStateVideoPanelAction = (isOpenVideoPanel, deviceId, channels, isOnlineVideo, dateStart, dateEnd, speedPlay) => {
  return {
    type: SET_VIDEO_PANEL_STATE,
    isOpenVideoPanel,
    deviceId,
    isOnlineVideo,
    dateStart,
    dateEnd,
    channels,
    speedPlay,
  };
};

const setStateVideoPanel = (isOpenVideoPanel, deviceId, channels = 0, isOnlineVideo, dateStart = null, dateEnd = null, speedPlay = 2) => {
  return (dispatch) => {
    dispatch(setStateVideoPanelAction(isOpenVideoPanel, deviceId, channels, isOnlineVideo, dateStart, dateEnd, speedPlay));
  };
};

const SET_VIDEO_INTERVAL = "SET_VIDEO_INTERVAL";

const setVideoIntervalAction = (dateStart, dateEnd) => {
  return {
    type: SET_VIDEO_INTERVAL,
    dateStart,
    dateEnd,
  };
};

const setVideoInterval = (dateStart, dateEnd) => {
  return (dispatch) => {
    dispatch(setVideoIntervalAction(dateStart, dateEnd));
  };
};

export { SET_VIDEO_PANEL_STATE, setStateVideoPanel, SET_VIDEO_INTERVAL, setVideoInterval };
